<template>
  <v-layout>
    <v-col>
      <v-row>
          <v-select
              label="Выберите показатель"
              v-model="selectedSensor"
              :items="sensors"
              item-title="name"
              item-value="id"
              density="compact"
              @update:model-value="updateChart()">
          </v-select>
      </v-row>
      <v-row>
          <v-select
              label="Выберите период"
              v-model="selectedPeriod"
              :items="periods"
              item-title="name"
              item-value="id"
              density="compact"
              @update:model-value="updateChart()">
          </v-select>
      </v-row>
      <v-row>
        <Chart :key="chartKey" :options="chartOptions" :data="chartData"></Chart>
      </v-row>
    </v-col>
  </v-layout>
</template>

<script>
import { Chart } from 'vue-chartjs'
import ChartJs from 'chart.js/auto'
import zoomPlugin from 'chartjs-plugin-zoom';
import moment from "moment";
import 'moment/locale/ru';
import axios from "axios";

moment.locale("ru")
ChartJs.register(zoomPlugin);

export default {
  name: 'MainComponent',
  components: {
    Chart,
  },
  props: {
    id: {
      type: String,
    },
  },
  data: () => ({
    chartKey: false,
    selectedSensor: 0,
    sensors: [],
    selectedPeriod: 1,
    periods: [
      { id: 1, name: "День" },
      { id: 2, name: "Неделя" },
      { id: 3, name: "Месяц" },
      { id: 4, name: "Год" }
    ],
    chartData: {
      labels: [],
      datasets: []
    },
    chartOptions: {
    }
  }),
  methods: {
    customization () {
      this.chartOptions = {
        animation: false,
        plugins: {
          zoom: {
            pan: {
              enabled: true,
              mode: 'xy',
            },
            limits: {
              y: {min: 0, max: 100},
            },
            zoom: {
              wheel: {
                enabled: true,
                mode: 'x',
              }
            },
          },
        }
      }

      let c1 = Math.max(...this.chartData.datasets[0].data)
      // let c2 = Math.max(...this.chartData.datasets[1].data)
      // this.chartOptions.plugins.zoom.limits.y.max =
      //     Math.max(c1, c2)  + Number(Math.max(c1, c2) / 100 * 20)
      // this.chartOptions.plugins.zoom.limits.y.min =
      //     Math.min(...this.chartData.datasets[0].data) > 0 ? 0 : Math.min(...this.chartData.datasets[0].data)
      this.chartOptions.plugins.zoom.limits.y.max = c1 + Number(c1 / 100 * 20)
    },
    updateChart() {
      let data = {
          sensor_id: this.selectedSensor,
          post_id: this.id,
          period_id: this.selectedPeriod
      }
      axios
        .post("/get-chart", {data})
        .then((response) => {
          let {
            datasets,
            labels
          } = this.prepData(response.data)
          this.chartData.labels = labels
          this.chartData.datasets = datasets
          this.chartOptions = {}
          if (this.selectedPeriod !== 4) {
            this.customization()
          }
          this.chartKey = !this.chartKey
        })
        .catch()
    },

    prepData(value) {
      let labels = [];
      let graphValue = [];
      // let graphTreshold = [];
      let datasets = [];
      value.forEach(a => {
        labels.push(new Date(a.date).toLocaleString());
        graphValue.push(a.value);
        // graphTreshold.push(a.treshold);
      })
      datasets.push({
          label: "Показатель, г/с",
          data: graphValue,
          type: 'line',
          borderColor: "#3F88C5",
          fill: false,
          tension: 0.1,
          pointRadius: 0
        }, 
        // {
        //   label: "Норматив, г/с",
        //   data: graphTreshold,
        //   type: 'line',
        //   borderColor: "#F64740",
        //   fill: false,
        //   tension: 0.1,
        //   pointRadius: 0
        // }
      )
      return {
        datasets,
        labels,
      };
    }
  },
  created() {
    let id = this.id
    axios
      .get("/get-sensors", {params:{id}})
      .then((response) => {
        this.sensors = response.data
        this.selectedSensor = this.sensors[0].id
        this.updateChart()
      })
      .catch()
  }
}
</script>
